import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowDown, ArrowUp } from '@/icons/ArrowUpDown';
import type { ActivitySortOrder } from '@/types/activity';

interface ActivitySortControlsProps {
  sortOrder: ActivitySortOrder;
  onSortOrderChange: (order: ActivitySortOrder) => void;
}

const ActivitySortControls: React.FC<ActivitySortControlsProps> = ({ sortOrder, onSortOrderChange }) => {
  const { t } = useTranslation('screens');

  const toggleDirection = () => {
    onSortOrderChange(sortOrder === 'asc' ? 'desc' : 'asc');
  };

  const directionLabel = sortOrder === 'asc' ? t('filters.oldestFirst') : t('filters.newestFirst');

  return (
    <div className="list-sort-controls">
      <span className="list-sort-controls__heading" id="activity-sort-label">
        {t('filters.sort')}
      </span>
      <div className="list-sort-controls__group">
        <span className="list-sort-controls__static-field" aria-hidden>
          {t('filters.sortDate')}
        </span>
        <button
          type="button"
          className="list-sort-controls__direction"
          onClick={toggleDirection}
          aria-labelledby="activity-sort-label"
          title={directionLabel}
          aria-label={directionLabel}
        >
          {sortOrder === 'asc' ? <ArrowUp width={16} height={16} /> : <ArrowDown width={16} height={16} />}
        </button>
      </div>
    </div>
  );
};

export default ActivitySortControls;
